import { createContext, FC, ReactNode, useMemo } from 'react';

import { useShadowContainer } from '@beeline/lk-utils';

import { useRequiredContext } from 'src/hooks/useRequiredContext';

export interface HostContextValue {
  host: ShadowRoot | Element | null;
}

export const HostContext = createContext<HostContextValue | undefined>(
  undefined,
);
HostContext.displayName = 'HostContext';

interface HostProviderProps {
  children?: ReactNode;
}

export const HostProvider: FC<HostProviderProps> = ({ children }) => {
  const rootElement = useShadowContainer();

  const contextValue = useMemo(
    (): HostContextValue => ({
      host: rootElement ?? document.getElementById('root'),
    }),
    [rootElement],
  );

  return (
    <HostContext.Provider value={contextValue}>{children}</HostContext.Provider>
  );
};

export const useHost = (): HostContextValue => useRequiredContext(HostContext);
